import { render } from "./WorkAreaFormModal.vue?vue&type=template&id=4a7e1ed6"
import script from "./WorkAreaFormModal.vue?vue&type=script&lang=ts"
export * from "./WorkAreaFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script